import { Cell } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';
import { formatDate, getInt } from 'coreOld/utils';
import { IInventory } from 'partsOld/types';

export const columns = (totals) => [
  {
    accessor: 'locationName',
    Header: 'Location',
    Footer: () => <CellText mainText="Totals" />,
  },
  {
    accessor: 'uom',
    Header: 'Uom',
    flex: 70,
  },
  {
    accessor: 'shipDays',
    Header: () => <CellText mainText="Ship Days" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={row.original.shipDays} alignText={AlignText.RIGHT} />
    ),
    flex: 100,
  },
  {
    accessor: 'standardCost',
    Header: () => <CellText mainText="Standard Cost" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={row.original.standardCost} alignText={AlignText.RIGHT} />
    ),
    flex: 120,
  },
  {
    accessor: 'quantityAvailable',
    Header: () => <CellText mainText="Available" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={getInt(row.original.quantityAvailable)} alignText={AlignText.RIGHT} />
    ),
    Footer: () => (
      <CellText mainText={getInt(totals?.quantityAvailable)} alignText={AlignText.RIGHT} />
    ),
    flex: 100,
  },
  {
    accessor: 'quantityAllocated',
    Header: () => <CellText mainText="Allocated" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={getInt(row.original.quantityAllocated)} alignText={AlignText.RIGHT} />
    ),
    Footer: () => (
      <CellText mainText={getInt(totals?.quantityAllocated)} alignText={AlignText.RIGHT} />
    ),
    flex: 100,
  },
  {
    accessor: 'quantityOnhand',
    Header: () => <CellText mainText="On Hand" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={getInt(row.original.quantityOnhand)} alignText={AlignText.RIGHT} />
    ),
    Footer: () => (
      <CellText mainText={getInt(totals?.quantityOnhand)} alignText={AlignText.RIGHT} />
    ),
    flex: 100,
  },
  {
    accessor: 'quantityBackorder',
    Header: () => <CellText mainText="Back Order" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => (
      <CellText mainText={getInt(row.original.quantityBackorder)} alignText={AlignText.RIGHT} />
    ),
    Footer: () => (
      <CellText mainText={getInt(totals?.quantityBackorder)} alignText={AlignText.RIGHT} />
    ),
    flex: 100,
  },
  {
    accessor: 'lastUpdateDate',
    Header: () => <CellText mainText="Last Update" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IInventory>) => {
      const date = formatDate(row.original.lastUpdateDate, true);

      return (
        <CellText
          mainText={date.split(' ')[0]}
          subTexts={[date.split(' ')[1]]}
          alignText={AlignText.RIGHT}
        />
      );
    },
    flex: 120,
  },
];
